// extracted by mini-css-extract-plugin
export default {"font-ruler-container":"MCgo3f","fontRulerContainer":"MCgo3f"};